import { Children } from 'react';

function findByType(type) {
  return this.find(child => child.type === type);
}

function filterByType(type) {
  return this.filter(child => child.type === type);
}

/**
 * Return array of renderable nodes enhanced by findByType and filterByType functions.
 * @param reactChildren
 * @return Array<ReactChild> & {
 *   findByType: (type: Object) => ReactChild,
 *   filterByType: (type: Object) => Array<ReactChild>,
 * }
 */
const parseChildren = (reactChildren) => {
  const children = Children.toArray(reactChildren);
  children.findByType = findByType;
  children.filterByType = filterByType;

  return children;
};

export default parseChildren;
